import { useState } from 'react';
import { ConfirmationDialog, BottomActionBarV2, AritoFormV2, DialogV2, AritoIcon } from '@/components/custom/erp';
import { DonViTinh, QuyDoiDonViTinhChiTiet, QuyDoiDonViTinhChiTietInput, VatTu } from '@/types/schemas';
import { formSchema, FormValues } from '../../schemas';
import { FormMode } from '@/types/form';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: QuyDoiDonViTinhChiTietInput) => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: QuyDoiDonViTinhChiTiet;
}
function FormDialog({
  mode,
  open,
  onClose,
  onSubmit,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData
}: FormDialogProps) {
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [donViTinh, setDonViTinh] = useState<DonViTinh | null>(initialData?.dvt_data || null);
  const [vatTu, setVatTu] = useState<VatTu | null>(initialData?.ma_vt_data || null);

  // Chuẩn bị dữ liệu ban đầu cho form
  const formInitialData = initialData
    ? { ...initialData, trang_thai: initialData.status }
    : { trang_thai: '1', he_so: 0 };

  const handleSubmit = async (data: FormValues) => {
    // Kiểm tra xem đã chọn Mã vật tư chưa
    if (!vatTu || !vatTu.uuid) {
      setErrorMessage('Vui lòng chọn Mã vật tư');
      setShowErrorDialog(true);
      return;
    }

    // Kiểm tra xem đã chọn Đvt chưa
    if (!donViTinh || !donViTinh.uuid) {
      setErrorMessage('Vui lòng chọn Đvt');
      setShowErrorDialog(true);
      return;
    }

    const hesoValue = data.he_so;
    if (isNaN(hesoValue) || hesoValue <= 0) {
      setErrorMessage('Hệ số không được để trống hoặc giá trị không hợp lệ');
      setShowErrorDialog(true);
      return;
    }

    try {
      const updatedData: QuyDoiDonViTinhChiTietInput = {
        ...data,
        dvt: donViTinh.uuid,
        ma_vt: vatTu.uuid,
        status: data.trang_thai
      };
      // Chỉ gọi onSubmit, không đóng form ở đây
      onSubmit(updatedData);
    } catch (err: unknown) {
      console.log(err);
    }
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={formInitialData as FormValues}
          className='w-full min-w-[700px]'
          headerFields={
            <BasicInfo
              mode={mode}
              donViTinh={donViTinh}
              setDonViTinh={setDonViTinh}
              vatTu={vatTu}
              setVatTu={setVatTu}
            />
          }
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>

      <ConfirmationDialog
        open={showErrorDialog}
        onClose={() => setShowErrorDialog(false)}
        onConfirm={() => setShowErrorDialog(false)}
        title='Thông báo'
        message={errorMessage}
        iconCode={260}
      />
    </>
  );
}

export default FormDialog;
